import { css } from "@emotion/css";
import { Colors } from "@snapchat/snap-design-system";

export const successfulPageContent = css`
    margin-top: 21px;
    padding: 16px 0 24px;
    background: #fff;
    border-radius: 6px;
`;

export const successfulPageText = css`
    width: 470px;
    padding-bottom: 16px;

    font-size: 14px;
    font-weight: 400;
    line-height: 17px;
    color: ${Colors.Black.V50};
    text-align: center;
    letter-spacing: 0.2px;
`;

export const businessManagerButton = css`
    margin-left: 20px;
`;

export const bodyContainerStyles = css`
    max-width: 500px;
    text-align: center;
`;
